import type { JSX } from "react";
import type { IColumnChartDataItem } from "pro-features/components/Chart/src/types";
import { EChartDisplayType } from "pro-features/components/Chart/src/configs/column-chart/columnChartConfig";
import { ColumnChart } from "pro-features/components/Chart/src/components/column/ColumnChart";
import { MarketSharesPeriodOverPeriod } from "app/pages/industry-analysis/players/market-shares/MarketSharesPeriodOverPeriod";
import { CHART_DISPLAY_TYPE_MD } from "app/pages/industry-analysis/players/market-shares/utils/utils";

type Props = {
    chartHeight: number;
    isPeriodOverPeriod: boolean;
    chartData: IColumnChartDataItem[];
    comparisonChartData?: IColumnChartDataItem[];
};

export const TopPlayersWidgetChart = ({
    chartHeight,
    isPeriodOverPeriod,
    chartData,
    comparisonChartData,
}: Props): JSX.Element => {
    const chartDisplayType = EChartDisplayType.PERCENTAGE;
    const { formatter } = CHART_DISPLAY_TYPE_MD[chartDisplayType];

    if (isPeriodOverPeriod && comparisonChartData) {
        return (
            <MarketSharesPeriodOverPeriod
                chartData={chartData}
                compareChartData={comparisonChartData}
                chartDisplayType={chartDisplayType}
                labelFormatter={formatter}
                config={{ chart: { height: chartHeight } }}
            />
        );
    }

    return (
        <ColumnChart
            chartData={chartData}
            displayOthersColumn={false}
            chartHeight={chartHeight}
        />
    );
};
